<div class="container-fluid h-100">
  <div class="row">
    <div class="col-12">
      <span class="title">{{ content.title }}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <p-divider styleClass="divider-m-5"></p-divider>
    </div>
  </div>
  <div class="container-fluid pb-3 container-content" [ngClass]="{'no-redirect': !content.dashboardRedirectPageFormId}">
    <div class="row py-2">
      <div class="col-12">
        <p-table [value]="pastHoliday" tableStyleClass="fb-past-holiday">
          <ng-template pTemplate="body" let-rowData>
            <tr>
              <td>{{rowData.id}}</td>
              <td>{{rowData.name}}</td>
              <td>{{rowData.date}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="row" *ngIf="!pastHoliday || pastHoliday.length === 0">
      <div class="col-12">
        <span class="no-data">No past holidays.</span>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <span class="table-title">Upcoming</span>
      </div>
    </div>
    <div class="row py-2">
      <div class="col-12">
        <p-table [value]="upcomingHoliday" tableStyleClass="fb-upcoming-holiday">
          <ng-template pTemplate="body" let-rowData>
            <tr [ngClass]="{'next-holiday': rowData.nextHoliday}">
              <td>{{rowData.id}}</td>
              <td>{{rowData.name}}</td>
              <td>{{rowData.date}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="row" *ngIf="!upcomingHoliday || upcomingHoliday.length === 0">
      <div class="col-12">
        <span class="no-data">No upcoming holidays.</span>
      </div>
    </div>
  </div>
  <div class="row pb-3" *ngIf="content.dashboardRedirectPageFormId">
    <div class="col-12 text-center">
      <a class="link" (click)="footerRedirect()">{{ content.footerLink }}</a>
    </div>
  </div>
</div>
